import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return true;
    const stored = localStorage.getItem("tk_theme");
    if (stored) return stored === "dark";
    return true;
  });
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("tk_theme", dark ? "dark" : "light");
  }, [dark]);
  return (
    <Button data-testid="theme-toggle-btn" variant="ghost" size="icon" onClick={() => setDark((d) => !d)} className="btn-push">
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
